export const fundAccountStatusColors = {
  new: 'cyan',
  waiting_customer: 'orange',
  pending: 'yellow',
  approved: 'green',
};

export const fundAccountStatusApprove = 'approved';

export const fundAccountESignStatusColors = {
  waiting_customer: 'orange',
  pending: 'yellow',
  finished: 'green',
};

export const fundAccountESignStatusLabels = {
  waiting_customer: 'Waiting for customer',
  pending: 'Pending',
  finished: 'Completed',
};

export const fundAccountESignStatusFinished = 'finished';

const fundAccountStatusRequest = 'request';
const fundAccountStatusPending = 'pending';
const fundAccountStatusNew = 'new';
// the customer needs to update info missing
const fundAccountStatusMissInfo = 'miss_info';
const fundAccountStatusApproved = 'approved';
const fundAccountStatusRejected = 'rejected';
// the customer has been suspended
const fundAccountStatusSuspended = 'suspended';

export const fundAccountStatusOptions = [
  fundAccountStatusRequest,
  fundAccountStatusPending,
  fundAccountStatusNew,
  fundAccountStatusMissInfo,
  fundAccountStatusApproved,
  fundAccountStatusRejected,
  fundAccountStatusSuspended,
];
